<template>
    <div id="search" v-if="isVisible">
        <form :action="route" method="GET" class="search default-form">
            <div class="wrap">
                <img src="/themes/default/img/icons/search.svg"
                     alt="search"
                     class="svg icon"
                     onload="SVGInject(this);"
                >
                <input type="text"
                       placeholder="Napíšte čo hladáte..."
                       name="s"
                       autocomplete="off"
                       v-model="value"
                       @input="input = true"
                >
                <button class="close" @click="isVisible = false">
                    <img src="/themes/default/img/icons/close.svg" alt="close">
                </button>
            </div>

            <div class="result" v-if="haveResults" v-html="resultsList"></div>

        </form>
    </div>
</template>

<script>
    import { debounce } from 'lodash';

    export default {
        props: {
            route: {
                required: true,
                type: String
            },
            inputPlaceholder: {
                required: true,
                type: String
            },
            buttonText: {
                required: true,
                type: String
            }
        },

        data() {
            return {
                isVisible: false,
                value: '',
                input: false,
                haveResults: false,
                resultsList: ''
            }
        },

        mounted() {
            this.$root.$on('openSearchForm', (value) => {
                this.isVisible = value;
            });
        },

        watch: {
            input: debounce( function () {
                if ( this.input === true) {
                    this.sendAjax();
                    this.input = false;
                }
            }, 400)
        },

        methods: {
            sendAjax() {

                if ( this.value.length > 2 ) {
                   axios.post(this.route,{ q: this.value })
                       .then( response => {
                           this.haveResults = true;
                           this.resultsList = response.data;

                       })
                       .catch( error => console.error(error) )
                } else this.haveResults = false;
            },
        }
    }
</script>
